module.exports = __webpack_public_path__ + "static/media/imago500ru.a15f2329.pdf";